import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=cc6df6f8&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Divider.vue"
export default component.exports